// Mock data for Park Skill website

export const companyInfo = {
  name: "Park Skill",
  tagline: "Development Organization",
  logo: "https://customer-assets.emergentagent.com/job_5cd568e4-88c7-499a-9a2e-55e1e2223c8c/artifacts/rpkb0df3_WhatsApp%20Image%202026-05-13%20at%2013.11.01.jpeg",
  phone: "8504001404",
  email: "apprenticeship@parkskills.in",
  website: "www.parkskills.in",
  address: "A-1902, Lashkaria Pearl, Behram Baug, Jogeswari (W) Mumbai 400102",
  mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3769.1234567890!2d72.8234!3d19.1234!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTnCsDA3JzI0LjQiTiA3MsKwNDknMjQuNCJF!5e0!3m2!1sen!2sin!4v1234567890"
};

export const partnerLogos = {
  nats: "https://customer-assets.emergentagent.com/job_096dd7b9-a5cd-488c-8de2-2d5f01408544/artifacts/xgbl9wjb_1.png",
  naps: "https://customer-assets.emergentagent.com/job_096dd7b9-a5cd-488c-8de2-2d5f01408544/artifacts/hutxcp7v_2.png",
  msde: "https://customer-assets.emergentagent.com/job_096dd7b9-a5cd-488c-8de2-2d5f01408544/artifacts/r6mji3wy_msde.png",
  moe: "https://customer-assets.emergentagent.com/job_096dd7b9-a5cd-488c-8de2-2d5f01408544/artifacts/6siqlpqe_Untitled-2%2011.png",
  sidh: "https://customer-assets.emergentagent.com/job_parkskill-rural/artifacts/bvph7eij_images.jfif",
  tssc: "https://customer-assets.emergentagent.com/job_parkskill-rural/artifacts/k4yaia5l_images%20%281%29.png",
  pmkvy: "https://customer-assets.emergentagent.com/job_parkskill-rural/artifacts/4wxm6v2l_PMKVY.png",
  skillIndia: "https://customer-assets.emergentagent.com/job_parkskill-rural/artifacts/elkt5dlt_Untitled-1%201.png",
  industryPartners: "https://customer-assets.emergentagent.com/job_parkskill-rural/artifacts/s9zolgh5_logo.png",
  industryPartnersAlt: "https://customer-assets.emergentagent.com/job_parkskill-rural/artifacts/62mm80t9_logo.png"
};

export const heroImages = [
  "https://images.unsplash.com/photo-1756885375569-f04400d99cee?w=1920&q=80",
  "https://images.unsplash.com/photo-1690356107486-0796de806f63?w=1920&q=80",
  "https://images.unsplash.com/photo-1759523146335-0069847ceb16?w=1920&q=80",
  "https://images.unsplash.com/photo-1758522275018-2751894b49c8?w=1920&q=80"
];

export const statistics = [
  { id: 1, value: 37, suffix: "+", label: "Establishments Collaborated", icon: "Building2" },
  { id: 2, value: 30000, suffix: "+", label: "Apprentices Trained", icon: "GraduationCap" },
  { id: 3, value: 6000, suffix: "+", label: "Candidates Placed", icon: "Briefcase" },
  { id: 4, value: 3000, suffix: "+", label: "Trained Under PMKVY STT", icon: "Award" }
];

export const services = [
  {
    id: 1,
    title: "Apprenticeship",
    description: "Training and enrollment under NATS & NAPS schemes with comprehensive TPA support for establishments.",
    icon: "GraduationCap",
    image: "https://images.unsplash.com/photo-1758522275031-70ea3febfa2e?w=600&q=80"
  },
  {
    id: 2,
    title: "WISE Program",
    description: "Work Integrated Skill-Based Education - Academic program embedded with skill training in collaboration with Industry and Skills University.",
    icon: "Award",
    image: "https://images.unsplash.com/photo-1756885375569-f04400d99cee?w=600&q=80"
  },
  {
    id: 3,
    title: "Skill Development",
    description: "Market-demand and future skills-based training programs designed to enhance employability.",
    icon: "Wrench",
    image: "https://images.unsplash.com/photo-1759523146335-0069847ceb16?w=600&q=80"
  },
  {
    id: 4,
    title: "Education",
    description: "Support for vocational and formal education linkage to create well-rounded professionals.",
    icon: "BookOpen",
    image: "https://images.pexels.com/photos/4491910/pexels-photo-4491910.jpeg?w=600"
  },
  {
    id: 5,
    title: "Placement",
    description: "Job opportunities post-training with our network of partner establishments across India.",
    icon: "Briefcase",
    image: "https://images.unsplash.com/photo-1690356107486-0796de806f63?w=600&q=80"
  },
  {
    id: 6,
    title: "Mobilisation",
    description: "Providing skilled candidates to establishments as per demand with quality assurance.",
    icon: "Users",
    image: "https://images.unsplash.com/photo-1758522275018-2751894b49c8?w=600&q=80"
  }
];

export const wiseProgram = {
  title: "WORK INTEGRATED SKILL-BASED EDUCATION (WISE)",
  description: "The Academic program is embedded with skill training. Academic Program is a collaboration between Industry and Skills University.",
  highlights: [
    "Creates fresh talents for employment at the supervisory/executive level for the industry",
    "100% of the program component constitutes On-the-Job Training (OJT) at Industry",
    "University awards a Degree/Diploma with certificates for skills training",
    "Students earn a recognized Degree/Diploma along with Industry Experience",
    "Practical training through OJT as per National Education Policy (NEP)"
  ],
  programs: [
    {
      name: "B.Voc (Bachelor of Vocation)",
      type: "Undergraduate Degree",
      eligibility: "12th standard pass / Diploma",
      ageLimit: "16 years and above"
    },
    {
      name: "D.Voc (Diploma of Vocation)",
      type: "Diploma Program",
      eligibility: "10th standard pass / ITI pass",
      ageLimit: "16 years and above"
    }
  ]
};

export const achievements = [
  {
    id: 1,
    title: "NATS TPA",
    description: "Affiliated with Ministry of Education's National Apprenticeship Training Scheme as Third Party Aggregator",
    logo: "nats",
    ministry: "Under MoE"
  },
  {
    id: 2,
    title: "NAPS Partner",
    description: "Registered partner with Ministry of Skill Development's National Apprenticeship Promotion Scheme",
    logo: "naps",
    ministry: "Under MSDE"
  },
  {
    id: 3,
    title: "Skill India Digital Hub",
    description: "Registered Training Partner on the official Skill India Portal (SIDH) for quality training delivery",
    logo: "sidh"
  },
  {
    id: 4,
    title: "TSSC Affiliate",
    description: "Affiliated with Telecom Sector Skill Council for specialized telecom training programs",
    logo: "tssc"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Rajesh Kumar",
    role: "Apprentice at Tata Motors",
    location: "Maharashtra",
    content: "Park Skill helped me get an apprenticeship at Tata Motors. The training was excellent and I'm now a full-time employee. My life has completely changed!",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop"
  },
  {
    id: 2,
    name: "Priya Sharma",
    role: "Skill Development Trainee",
    location: "Uttar Pradesh",
    content: "Coming from a rural village, I never thought I could get such quality training. Park Skill's PMKVY program gave me the skills I needed to start my own business.",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop"
  },
  {
    id: 3,
    name: "Mohammed Irfan",
    role: "Placed at L&T",
    location: "Gujarat",
    content: "The placement support from Park Skill was incredible. They didn't just train me, they made sure I got a good job. Forever grateful!",
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&h=100&fit=crop"
  },
  {
    id: 4,
    name: "Sunita Devi",
    role: "Entrepreneur",
    location: "Bihar",
    content: "After completing skill training, I started my own tailoring business. Park Skill empowered me to become financially independent.",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop"
  }
];

export const futureGoals = [
  { target: 50, label: "New Establishments in 5 Years" },
  { target: 50000, label: "Candidates to Train & Place" }
];

export const natsInfo = {
  title: "NATS - National Apprenticeship Training Scheme",
  ministry: "Ministry of Education (MoE)",
  description: "NATS provides practical training to graduates and diploma holders in engineering and technology. It bridges the gap between theoretical knowledge and practical skills required in industries.",
  benefits: [
    "Practical training for graduates/diploma holders",
    "Monthly stipend with Government reimbursement",
    "Hands-on industry experience",
    "Enhanced employability",
    "Certificate from Government of India"
  ],
  eligibility: [
    "Any Indian registered company can participate",
    "Mandatory for establishments with 30+ employees",
    "Must have adequate training facilities"
  ]
};

export const napsInfo = {
  title: "NAPS - National Apprenticeship Promotion Scheme",
  ministry: "Ministry of Skill Development & Entrepreneurship",
  description: "NAPS promotes apprenticeship training by providing financial incentives to employers. It covers all sectors and trades, making skill development accessible to all.",
  benefits: [
    "Stipend sharing up to Rs 1,500/month by Government",
    "Basic training cost support up to Rs 7,500",
    "Wide range of designated and optional trades",
    "No upper age limit for apprentices",
    "Flexible duration from 6 months to 3 years"
  ],
  eligibility: [
    "Establishments with workforce of 4 or more",
    "Mandatory 2.5-15% apprentices for 30+ workforce",
    "Registered on apprenticeshipindia.gov.in",
    "Valid GSTIN/PAN"
  ]
};

export const tpaRole = {
  title: "Our Role as TPA",
  description: "As an affiliated Third Party Aggregator, Park Skill helps establishments seamlessly implement apprenticeship programs.",
  services: [
    "Candidate mobilization and screening",
    "Documentation and enrollment support",
    "Training program implementation",
    "Compliance with Apprentices Act 1961",
    "Stipend disbursement management",
    "Government reimbursement processing",
    "Registration on NATS & NAPS portals"
  ]
};

export const establishmentRequirements = {
  title: "Requirements for New Establishments",
  documents: [
    "PAN Card of the establishment",
    "TAN Number",
    "EPFO Registration (if applicable)",
    "ESIC Registration (if applicable)",
    "Aadhaar-linked bank account details",
    "GST Certificate",
    "Certificate of Incorporation/Registration",
    "Last 2 Years ITR (Income Tax Return)",
    "Official Website and Email ID",
    "Last 2 Months PF/ESIC Challan Copy"
  ],
  benefits: [
    "Access to skilled manpower",
    "Government stipend reimbursement",
    "Tax benefits under Income Tax Act",
    "Compliance with Apprentices Act",
    "Dedicated support from Park Skill team"
  ]
};

export const pmkvyInfo = {
  title: "PMKVY - Pradhan Mantri Kaushal Vikas Yojana",
  description: "PMKVY is the flagship scheme of the Ministry of Skill Development & Entrepreneurship. It provides short-term training to youth for employability and entrepreneurship.",
  highlights: [
    "Free of cost training for candidates",
    "Recognition of Prior Learning (RPL)",
    "Placement assistance",
    "NSQF aligned courses",
    "Industry-relevant curriculum"
  ],
  achievement: "Park Skill has trained over 3,000+ candidates under PMKVY STT"
};

export const aboutContent = {
  intro: "Park Skill Development Organization has been working in skill development, education, apprenticeship, and placement for the past 8 years. We are committed to empowering rural youth and contributing to the Skill India and Atmanirbhar Bharat missions.",
  mission: "Our mission is to reach every village and home in rural India for skill development and apprenticeship. We aim to create new employment opportunities and make India a skill hub by bridging the gap between education and industry requirements.",
  vision: "To be the leading organization in skill development and apprenticeship training, transforming lives of millions of rural youth across India and contributing to the nation's economic growth.",
  history: [
    { year: "2017", event: "Founded with a vision to empower rural youth" },
    { year: "2018", event: "Registered as Training Partner on Skill India Portal" },
    { year: "2019", event: "Started PMKVY STT programs" },
    { year: "2020", event: "Crossed 10,000 apprentices trained milestone" },
    { year: "2021", event: "Expanded partnerships with major establishments" },
    { year: "2022", event: "Affiliated with NAPS as Third Party Aggregator" },
    { year: "2023", event: "Affiliated with NATS as Third Party Aggregator" },
    { year: "2024", event: "Reached 30,000+ apprentices trained, 37+ establishments" },
    { year: "2025", event: "Targeting 50,000 candidates in next 5 years" }
  ]
};

export const careerSectors = [
  "Manufacturing",
  "IT/ITES",
  "Healthcare",
  "Retail",
  "Telecom",
  "Automotive",
  "Construction",
  "Hospitality",
  "Banking & Finance",
  "Logistics"
];

export const navItems = [
  { label: "Home", path: "/" },
  { label: "About Us", path: "/about" },
  { label: "Apprenticeship", path: "/apprenticeship" },
  { label: "Projects", path: "/projects" },
  { label: "Services", path: "/services" },
  { label: "Careers", path: "/careers" },
  { label: "Contact", path: "/contact" }
];
